import { render, staticRenderFns } from "./trap_types.vue?vue&type=template&id=6d06aa36&"
import script from "./trap_types.vue?vue&type=script&lang=js&"
export * from "./trap_types.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports